import React from 'react'
import { Provider } from 'react-redux'

import SeparateDatePicker from '../components/separate_date_picker'
import Themed from 'store/v2/react/components/Themed'

const store = window.booqableStore

export default class SeparateDatePickerContainer extends React.Component {
  static displayName = 'SeparateDatePicker'

  render = () => {
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <SeparateDatePicker {...this.props} />
          </div>
        </Themed>
      </Provider>
    )
  }
}
